export enum AddressTypeEnum {
  home = 'home',
  contact = 'contact',
  comercial = 'comercial'
}